'use client';

import { useRouter } from 'next/navigation';
import SafeBrowserRouter from './SafeBrowserRouter';
import { Toaster } from 'react-hot-toast';
import Header from './Header';
import Footer from './Footer';
import { useTheme } from '../hooks/useTheme';
import { HeaderRouterProvider } from '../contexts/HeaderRouterContext';
import AvailableEventsPage from '../views/AvailableEventsPage';
import EventDTO, { ProvinceDTO, PublicCategoryDTO } from '../models/event';
import { BusinessDTO } from '../models/business';

interface HomePageClientProps {
  preloadedEvents: EventDTO[];
  preloadedCategories?: PublicCategoryDTO[];
  preloadedProvinces?: ProvinceDTO[];
  /** Set when the request host maps to a producer; renders its landing directly. */
  preloadedBusiness?: BusinessDTO | null;
}

export default function HomePageClient({
  preloadedEvents, preloadedCategories, preloadedProvinces, preloadedBusiness,
}: HomePageClientProps) {
  useTheme();
  const router = useRouter();

  return (
    <HeaderRouterProvider>
      <SafeBrowserRouter>
        <div className="flex flex-col">
          <Header />
          <div>
            <Toaster />
          </div>
          <div className="relative flex-grow text-text-secondary overflow-visible px-2 lg:px-6 bg-opacity-light">
            <AvailableEventsPage
              loadedEvents={preloadedEvents}
              loadedCategories={preloadedCategories}
              business={preloadedBusiness ?? undefined}
              onNavigate={(path) => router.push(path)}
            />
          </div>
          <Footer categories={preloadedCategories} provinces={preloadedProvinces} />
        </div>
      </SafeBrowserRouter>
    </HeaderRouterProvider>
  );
}
